var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncrement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3f6d6e",
    d: "M4.653.347h15c2.209 0 4 1.791 4 4v15c0 2.21-1.791 4-4 4h-15c-2.21 0-4-1.79-4-4v-15c0-2.209 1.79-4 4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M19 12c0-.509-.412-.921-.921-.921H12.92V5.92c0-.509-.412-.921-.921-.921-.509 0-.921.412-.921.921v5.158H5.92c-.509 0-.921.412-.921.921 0 .509.412.921.921.921h5.158v5.158c0 .509.412.921.921.921.509 0 .921-.412.921-.921V12.92h5.158c.509 0 .921-.412.921-.921z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrement);
export default __webpack_public_path__ + "static/media/Increment.4605be5f34d68a628647141011bf0912.svg";
export { ForwardRef as ReactComponent };